export const mockData = {
  projects: [
    { id: 1, name: "3rd Ave" }
  ],
  
  workers: [
    { id: 1, name: "Jesus Garcia", rate: 95 },
    { id: 2, name: "Mike Rodriguez", rate: 95 },
    { id: 3, name: "Sarah Johnson", rate: 85 },
    { id: 4, name: "Tom Wilson", rate: 90 }
  ],

  laborEntries: [],

  materialEntries: [],

  costCodes: [
    "FP-Install",
    "FP-Rough",
    "FP-Test",
    "FP-Finish",
    "General"
  ],

  unitsOfMeasure: [
    "Each",
    "Foot",
    "Linear Foot",
    "Square Foot",
    "Gallon",
    "Pound",
    "Box",
    "Roll"
  ]
};